import React from 'react';
import { connect } from 'react-redux';
import * as selectors from 'selectors/pathBuilder';
import PathRenderer from '../../ContentList/PathRenderer';
import ContentTitle from './ContentTitle';
import { LessonBody } from './Lesson';
import ContentPerformanceFigures from './ContentPerformanceFigures';

const PathComponent = ({
  title,
  urls,
  type,
  parent,
  contents,
  pathContentId,
}) => (
  <div className="PerformanceContent">
    <div className="d-f jc-sb">
      <ContentTitle {...{ title, parent, urls, type }} />
      <ContentPerformanceFigures for={pathContentId} />
    </div>
    <div className="PerformanceContent-contents">
      {contents.map(content => (
        <LessonBody key={content.id} {...content} />
      ))}
    </div>
  </div>
);

const PathRendererComponent = props =>
  new PathRenderer({
    groupComponent: ({ children }) => <div>{children}</div>,
    pathComponent: PathComponent,
    startingPosition: props.stepNumber,
    renderHeaders: false,
    pathData: props,
  });

const mapStateToProps = () => {
  const getStepNumber = selectors.getStepNumber();
  return (state, props) => ({
    stepNumber: getStepNumber(state.pathBuilder, props),
  });
};

export default connect(mapStateToProps)(PathRendererComponent);
